import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Form } from "react-bootstrap";
import { Button } from 'primereact/button';
import axios from 'axios';
import config from '../config';
import { useAuth } from '../context/AuthContext';
import successVideo from '../assets/video/paperplane.mp4';
import crossVideo from '../assets/video/cross.mp4';
import { Dialog } from "primereact/dialog";

const AdvertisingTracking = ({ brandId }) => {
    const { accessToken, role } = useAuth();
    const [advertisingTracking, setAdvertisingTracking] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false); // New state for submit button
    const [editDialogVisible, setEditDialogVisible] = useState(false);
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog
    const allowedRoles = [
        'Founder', 'Admin', 'SuperAdmin', 'HumanResource',
        'Social_Media_Manager', 'Task_manager'
    ];
    const fetchAdvertisingTracking = async () => {
        try {
            const response = await axios.get(
                `${config.apiBASEURL}/BrandBookRoutes/brand-AdvertisingPerformance/${brandId}`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );
            setAdvertisingTracking(response.data);
        } catch (err) {
            console.error("Error fetching brand overview:", err);

        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (brandId) {
            fetchAdvertisingTracking();
        }
    }, [brandId, accessToken]);

    const handleEditClick = () => {
        setEditDialogVisible(true);
    };

    const handleadvertisingTrackingChange = (e) => {
        const { name, value } = e.target;
        setAdvertisingTracking((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async () => {
        setSubmitLoading(true); // Start loading
        try {
            const response = await axios.put(
                `${config.apiBASEURL}/BrandBookRoutes/brand-AdvertisingPerformance/${advertisingTracking.ad_id}/${brandId}`,
                advertisingTracking,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );

            if (response.status === 200) {
                setEditDialogVisible(false);
                setVideoDialogVisible(true);
                setTimeout(() => {
                    setVideoDialogVisible(false);
                    fetchAdvertisingTracking();
                }, 5000);
            }
        } catch (error) {
            console.error("Error updating brand overview:", error);
            setVideocrossDialogVisible(true);
            setTimeout(() => {
                setVideocrossDialogVisible(false);
            }, 5000);
        } finally {
            setSubmitLoading(false); // Stop loading
        }
    };


    if (loading) return <p>Loading...</p>;
    return (
        <>
            <Card className="view-card">
                <Card.Header className="h6 border-0 bg-light d-flex justify-content-between align-items-center">
                    <div>
                        Advertising & Performance Tracking
                        <small className="text-danger d-block mt-1" style={{fontSize: '12px'}}>
                            Last Update: {advertisingTracking?.updatedAt ? new Date(advertisingTracking.updatedAt).toLocaleString('en-GB') : 'N/A'}
                        </small>
                    </div>
                    
                    <div className="d-flex align-items-center">
                        <small className="text-warning ">
                            {allowedRoles.includes(role) && (
                                <Button
                                    title="Edit"
                                    icon="pi pi-pencil"
                                    className="p-0 border-0"
                                    text
                                    severity="help"
                                    onClick={handleEditClick}
                                />
                            )}      
                            
                        </small>
                    </div>
                </Card.Header>
                <Card.Body className="p-0 pb-2 ">
                    <Table className="brandTable">
                        <tbody>
                            <tr>
                                <th className="text-start">Ad Platforms Used:</th>
                                <td>
                                    {advertisingTracking?.ad_platforms_used}
                                </td>
                            </tr>
                            <tr className="table-light">
                                <th className="text-start text-secondary" colSpan={2}><b>Ad Budget Allocation:</b></th>
                            </tr>
                            <tr>
                                <th className="text-start">Monthly:</th>
                                <td>
                                    {advertisingTracking?.monthly_budget}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Quarterly:</th>
                                <td>
                                    {advertisingTracking?.quarterly_budget}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Best-Performing Ads & Learnings:</th>
                                <td>
                                    {advertisingTracking?.best_performing_ads}
                                </td>
                            </tr>
                            <tr className="table-light">
                                <th className="text-start text-secondary" colSpan={2}><b>KPIs & Metrics Tracked:</b></th>
                            </tr>
                            <tr>
                                <th className="text-start">Engagement Rate</th>
                                <td>
                                    {advertisingTracking?.engagement_rate}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Follower Growth</th>
                                <td>
                                    {advertisingTracking?.follower_growth}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Conversion Rate</th>
                                <td>
                                    {advertisingTracking?.conversion_rate}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Reach & Impressions</th>
                                <td>
                                    {advertisingTracking?.reach_impressions}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Other</th>
                                <td>
                                    {advertisingTracking?.other_metrics}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Tracking & Reporting Tools Used</th>
                                <td>
                                    {advertisingTracking?.tracking_reporting_tools}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Competitor Benchmarking Insights</th>
                                <td>
                                    {advertisingTracking?.competitor_benchmarking}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {/* Edit Dialog */}
            <Dialog
                header="Edit Brand Overview"
                visible={editDialogVisible}
                style={{ width: '50vw' }}
                onHide={() => setEditDialogVisible(false)}
                footer={
                    <div>
                        <Button label="Cancel" icon="pi pi-times" severity="danger" onClick={() => setEditDialogVisible(false)} className="p-button-text py-2" />
                        <Button
                            label={submitLoading ? "Saving..." : "Save"}
                            icon={submitLoading ? "pi pi-spin pi-spinner" : "pi pi-check"}
                            severity="success"
                            onClick={handleSubmit}
                            disabled={submitLoading}
                            autoFocus
                            className="py-2"
                        />
                    </div>
                }
            >
                <Row className="mx-0" style={{ height: '70vh', overflowY: 'auto' }}>
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Ad Platforms Used</Form.Label>
                        <Form.Control as="textarea" name="ad_platforms_used" value={advertisingTracking.ad_platforms_used} onChange={handleadvertisingTrackingChange} rows={2} />
                    </Col>

                    {/* Ad Budget Allocation Section */}
                    <Col md={12} lg={12} className="mb-3 px-1 h6">Ad Budget Allocation</Col>

                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Monthly</Form.Label>
                        <Form.Control type="text" name="monthly_budget" value={advertisingTracking.monthly_budget} onChange={handleadvertisingTrackingChange} />
                    </Col>

                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Quarterly</Form.Label>
                        <Form.Control type="text" name="quarterly_budget" value={advertisingTracking.quarterly_budget} onChange={handleadvertisingTrackingChange} />
                    </Col>

                    {/* Best Performing Ads */}
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Best-Performing Ads & Learnings</Form.Label>
                        <Form.Control as="textarea" name="best_performing_ads" value={advertisingTracking.best_performing_ads} onChange={handleadvertisingTrackingChange} rows={3} className="h-auto"/>
                    </Col>

                    {/* KPIs & Metrics Section */}
                    <Col md={12} lg={12} className="mb-3 px-1 h6">KPIs & Metrics Tracked</Col>

                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Engagement Rate</Form.Label>
                        <Form.Control type="text" name="engagement_rate" value={advertisingTracking.engagement_rate} onChange={handleadvertisingTrackingChange} />
                    </Col>

                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Follower Growth</Form.Label>
                        <Form.Control type="text" name="follower_growth" value={advertisingTracking.follower_growth} onChange={handleadvertisingTrackingChange} />
                    </Col>

                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Conversion Rate</Form.Label>
                        <Form.Control type="text" name="conversion_rate" value={advertisingTracking.conversion_rate} onChange={handleadvertisingTrackingChange} />
                    </Col>

                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Reach & Impressions</Form.Label>
                        <Form.Control type="text" name="reach_impressions" value={advertisingTracking.reach_impressions} onChange={handleadvertisingTrackingChange} />
                    </Col>

                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Other</Form.Label>
                        <Form.Control type="text" name="other_metrics" value={advertisingTracking.other_metrics} onChange={handleadvertisingTrackingChange} />
                    </Col>

                    {/* Tracking & Reporting Tools */}
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Tracking & Reporting Tools Used</Form.Label>
                        <Form.Control as="textarea" name="tracking_reporting_tools" value={advertisingTracking.tracking_reporting_tools} onChange={handleadvertisingTrackingChange} rows={3} className="h-auto"/>
                    </Col>

                    {/* Competitor Benchmarking */}
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Competitor Benchmarking Insights</Form.Label>
                        <Form.Control as="textarea" name="competitor_benchmarking" value={advertisingTracking.competitor_benchmarking} onChange={handleadvertisingTrackingChange} rows={3} className="h-auto" />
                    </Col>
                </Row>
            </Dialog>

            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>


            <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideocrossDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
            </Dialog>

        </>
    );
};

export default AdvertisingTracking
